export const AddMembersDTRModal: string = 'AddMembersDTRModal';
